import { orderTypes, ProductFilterItemArray } from '../modules/filters/models/product-filter.models';

import { CategoryNavMenus } from '@pages/category/models/category-nav-menus.model';

export interface CategoryFilterState {
    filters: ProductFilterItemArray[]; // Objecto de filtros para armar modulo
    isApplied: boolean;
    order: CategoryOrderState;
}
export interface CategoryOrderState {
    orderType: orderTypes;
    isApplied: boolean;
}

export interface MenuCategoriesState {
    navMenuCategories: CategoryNavMenus;
    filterTypeUsedAsSubcategories: string;
}

export type ProductNavigationAction = 'NEXT' | 'NONE' | 'PREV';

export interface ProductNavigation {
    selectedProductId: number;
    ProductsIds: number[];
    action: ProductNavigationAction;
}

export enum CustomCategories {
    ITX_TINYBIRD_V0_EP_RECOMMENDATIONS = 'inditex_tinybird_v0_ep_recommendations',
    ITX_MECACO_OYML_PERSONALIZATION_SORT = 'oyml_personalization_sort',
}
